import "./Terms.css";
import { Helmet } from "react-helmet-async";

export const TermsPage = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions | Yuva Quest</title>
        <link rel="canonical" href="https://yuvaquest.com/terms" />
        <meta
          name="description"
          content="Understand the rules, responsibilities, and limitations that govern your use of Yuva Quest."
        />
      </Helmet>

      <div className="webUi my_custom_section ">
        <p className="webUi">Terms & Condition</p>
      </div>

      <div className="formdiv container ">
        <p className="webUi">
          This document is an electronic record in terms of Information
          Technology Act, 2000 and the amended provisions pertaining to
          electronic records in various statutes as amended by the Information
          Technology Act, 2000. This electronic record is generated by a
          computer system and does not require any physical or digital
          signatures.
          <br />
          This is an agreement between you, being any user who is browsing
          through the Website and/or the Application, irrespective of whether
          they purchase/subscribe to the Products (defined below), or not{" "}
          <strong>
            (“you” or “end user” or “your” or “customer” or “user”)
          </strong>{" "}
          and River Comics LLC <strong>(“River Comics” or “we” or “us”)</strong>
          .
          <br />
          You understand and agree that by mere use of the Website and/or the
          Application, you shall be contracting with River Comics, and that
          these terms and conditions <strong>(“Terms“)</strong>, constitute your
          constitute your binding obligations, with River Comics. Please read
          the following Terms carefully. These Terms govern your access to and
          use of the Yuva Quest mobile application{" "}
          <strong>(“Application”)</strong>, Yuva Quest website www.yuvaquest.com{" "}
          <strong>(“Website”)</strong> and any Services (defined below). The
          Application, Website and Services are hereafter in these Terms,
          collectively referred to as the <strong>“Program“</strong>. By
          downloading the Application and/or accessing the Website, or accessing
          and/or using any part of the Program, you agree that you have read and
          understood these Terms and agree to be bound by these Terms.
          <br />
          In addition to these Terms, the sale/purchase of Products on the
          Website/the Application shall also be governed by the cancellation
          policy, exchange policy, return policy, etc. of River Comics (which
          are available on the Website/the Application), all of which are
          incorporated in these Terms by reference, and shall constitute your
          binding obligations towards River Comics. Further, you will also be
          bound by specific terms and conditions as may be applicable to any of
          the Products, which may be displayed separately along with the other
          information pertaining to the respective Products on the
          Website/Application. In case of any contradiction between these
          conditions and the Terms, the specific terms and conditions would
          prevail.
        </p>
        <h5 className="webUi">Purpose of the Website</h5>
        <p className="webUi">
          All the content contained in the Website/Application is provided for
          informational purposes only and shall not be construed as a commercial
          offer, a license, an advisory, fiduciary or professional relationship
          between you and River Comics. No information provided on this
          Website/Application shall be considered a substitute for your
          independent investigation. The information provided on the
          Website/Application may be related to products or services that are
          not available in your country.
        </p>
        <h5 className="webUi">Intellectual Property</h5>
        <p className="webUi">
          River Comics LLC is the sole and exclusive owner of all rights, title,
          and interest in and to the Yuva Quest trademark, brand, and all
          associated intellectual property, including but not limited to logos,
          characters, storylines, designs, and other proprietary content. Any
          unauthorized use, reproduction, or distribution of the Yuva Quest
          brand or related materials is strictly prohibited and may result in
          legal action.
          <br />
          The Program and all content therein is the exclusive property of River
          Comics except where provided otherwise. Any material that it contains,
          including, but not limited to, texts, data, graphics, pictures,
          sounds, videos, logos, icons or html code is protected under the
          intellectual property laws and remains River Comics’ property, except
          where provided otherwise.
          <br />
          You may use this material for personal and non-commercial purposes in
          accordance with the principles governing intellectual property laws.
          Any other use or modification of the content of the Program without
          River Comics’ prior written authorisation is prohibited.
        </p>
        <h5 className="webUi">Services</h5>
        <p className="webUi">
          River Comics may provide a number of internet-based interactive and
          informational services through the Application and/or the Website{" "}
          <strong>(“Services“)</strong>, including but not limited to: “text,
          software, scripts, graphics, photos, sounds, music, videos,
          audiovisual combinations, interactive features and other materials you
          may view on, access through, or contribute to the Service. The Service
          includes all aspects of River Comics, including but not limited to all
          products, software and services offered via the Website/Application.
          <br />
          The Services may contain links to third party websites that are not
          owned or controlled by River Comics. River Comics has no control over,
          and assumes no responsibility for, the content, privacy policies, or
          practices of any third party websites. In addition, River Comics will
          not and cannot censor or edit the content of any third-party site. By
          using the Service, you expressly relieve River Comics from any and all
          liability arising from your use of any third-party website.
          <br />
          Accordingly, we encourage you to be aware when you leave the Service
          and to read the terms and conditions and privacy policy of each other
          website that you visit.. You will always have control over the Push
          Messages settings, and can opt in or out of these Push Messages, with
          the possible exception of infrequent, important service announcements
          and administrative messages. Please be aware that messaging fees may
          apply depending on the message plan you have with your wireless
          carrier.
        </p>
        <h5 className="webUi">Registration</h5>
        <p className="webUi">
          In order to avail the Services, you shall have to create an “Account”
          with us, which will be authenticated using Facebook/Gmail and or other
          official means of authentication. To create an Account and participate
          in the Program, you must be 13 years of age and older at the time of
          registration. If you are younger than 13 years of age, then you need
          to ensure your parents consent to your using the Services.
          <br />
          Use of the Services by anyone under the age of thirteen (13) is
          unauthorized and unlicensed. In all cases, if you are under thirteen
          (13) years old, you may only use the Service with the approval of your
          parents or guardian
          <br />
          You will be solely responsible for any activities or actions taken
          under your Account, whether or not authorized by you. Please notify us
          immediately of any unauthorized use or breach of your Account or
          password. You shall be responsible for maintaining the confidentiality
          of your Account, username and password at all times, and you alone
          shall be responsible for all activities that may occur under your
          username and password. We are not liable for any loss or damage from
          your failure to comply with these requirements.
          <br />
          By creating an Account you consent to the use of: (i) electronic means
          to complete the Terms and to provide you with any notices to be given
          pursuant to the Terms; and (ii) electronic records to store
          information related to the Terms or related to your use of the
          Program.
          <br />
          By creating an Account, you represent, warrant and covenant that the
          information you provide us (including, but not limited to your name,
          username, e-mail address, age and sex) will be true, accurate, current
          and complete, and that in future, you shall keep such information
          accurate and up-to-date at all times. Failure to do so shall
          constitute a breach of these Terms, which may result in immediate
          termination of your Account with us.
          <br />
          You shall not:
          <br />a{")"} provide any false personal information to River Comics
          (including a false username) or create any account for anyone other
          than yourself without such person’s permission;
          <br />b{")"} use a username that is the name of another person with
          the intent to impersonate that person;
          <br />c{")"} use a username or the Account that is subject to any
          rights of a person other than you without appropriate authorization;
          or
          <br />d{")"} use a username that is a name that is otherwise
          offensive, vulgar or obscene or otherwise unlawful.
        </p>
        <h5 className="webUi">License</h5>
        <p className="webUi">
          Subject to your compliance with the Terms, you may (1) download and
          install one copy of the Application to your supported device, and
          access and use the Services, solely for your own personal and
          non-commercial use (2) access the Services through the Website. You
          may not: (i) copy, modify or distribute the Program for any purpose;
          (ii) transfer, sublicense, lease, lend, rent or otherwise distribute
          the Program to anyone else; (iii) reverse-engineer, decompile or
          create derivative works of the Program; (iv) make the functionality of
          the Program available to multiple users through any means; (v) use
          multiple accounts per individual user per device; or (v) use the
          Services in any unlawful manner, for any unlawful purpose, or in any
          manner inconsistent with the Terms. No other licenses or rights are
          granted to you by implication or otherwise under any intellectual
          property rights owned or controlled by River Comics or its licensors.
        </p>
        <h5 className="webUi">Payment</h5>
        <p className="webUi">
          While availing any of the payment method/s available on the Program,
          we will not be responsible or assume any liability, whatsoever in
          respect of any loss or damage caused directly or indirectly to you,
          due to:
          <br />
          1. Lack of authorization for any transaction/s, or
          <br /> 2. Exceeding the preset limit mutually agreed by You and
          between “Bank/s”, or
          <br />
          3. Any payment issues arising out of the transaction, or
          <br /> 4. Decline of transaction for any other reason/s.
          <br />
          The Program will not facilitate transaction with respect to any other
          form of currency.
          <br />
          Before delivering the purchased Products to you, Merchant may request
          you to provide supporting documents (including but not limited to
          Govt. issued ID and address proof) to establish the ownership of the
          payment instrument used by you for your purchase. This is done in the
          interest of providing a safe online shopping environment. You agree to
          cooperate with any such requests from the Merchant and provide the
          information as may be required.
          <br />
          Further, you understand and agree that, :
          <br />
          1. Transactions, transaction price and all commercial terms such as
          delivery, dispatch of Products and/or Services are on a principal to
          principal basis, being bipartite contractual obligations between the
          buyer and the seller and payment facility on the Website/ the
          Application, is merely used by the buyer and the seller to facilitate
          the completion of the transaction. Use of the payment facility shall
          not render us liable or responsible for the non-delivery, non-receipt,
          non-payment, damage, breach of representations and warranties,
          non-provision of after sales or warranty services or fraud as regards
          the Products and /or Services listed on the Program.
          <br />
          2. You have specifically authorized us or our service providers to
          collect, process, facilitate and remit payments electronically or
          through Cash on Delivery in respect of the transactions made by you
          through our Website/ Application. Entered into through the Program.
          <br />
          3. You understand, accept and agree that the payment facility provided
          by us is neither a banking nor financial service but is merely a
          facilitator providing an electronic, automated online electronic
          payment, receiving payment through Cash On Delivery, collection and
          remittance facility for the Services availed through the River Comics
          Program using the existing authorized banking infrastructure and
          Credit Card payment gateway networks. Further, by providing facility
          for payment, we are neither acting as trustees nor acting in a
          fiduciary capacity with respect to the transaction carried out through
          the Program.
          <br />
          The Subscription Fees specified for each Subscription plan are
          inclusive of applicable taxes. River Comics reserves the right to
          change, terminate or otherwise amend the Subscription plans,
          Subscription Fees for the Subscription and billing cycles at its sole
          discretion and at any time. Such amendments shall be effective upon
          posting on the Site and Your continued use of the Service shall be
          deemed to be Your conclusive acceptance of such amendments.
          <br />
          River Comics reserves the right to change, supplement, alter or remove
          any of the Content that is subject to a Subscription Fee as it deems
          fit. River Comics does not guarantee the availability of a specific
          Content or a minimum Content that is subject to a Subscription Fee.
        </p>
        <h5 className="webUi">Refunds</h5>
        <p className="webUi">
          You can cancel your purchase and receive a refund as long as you have
          not commenced using the relevant Paid Service ordered and you make
          your request no later than {localStorage.getItem("trial_days")}{" "}
          working days after your order is completed. Please note that if your
          order includes a free trial (as described below), the{" "}
          {localStorage.getItem("trial_days")} day period for requesting a
          refund begins at the beginning of the free trial, not when you are
          subsequently billed for the Paid Service. Requests for refunds must be
          directed to our customer support team by clicking “Help” next to the
          relevant purchase on your Purchases page or by contacting the customer
          support team here. We reserve the right to approve or deny refund
          requests after 3 working days at our sole discretion, except where the
          Paid Service is defective. In the event a refund is issued after{" "}
          {localStorage.getItem("trial_days")} days for any subscription Paid
          Service, you may be issued a partial refund that is pro-rated for the
          remaining time left on the subscription. If you receive a refund for
          any reason, River Comics reserves the right to terminate your access
          to the relevant Paid Service purchased
        </p>
        <h5 className="webUi">Subscription Cancellations</h5>
        <p className="webUi">
          If you purchase a subscription to a Paid Service that automatically
          renews, you may cancel the subscription any time before the end of the
          current billing period and the cancellation will take effect on the
          next billing period. You will retain access to the Paid Service from
          the time you cancel until the start of the next billing period, and
          will not receive a refund or credit for any remaining days in your
          current billing period.{" "}
        </p>
        <h5 className="webUi">Free Trials</h5>
        <p className="webUi">
          River Comics may offer free trials to new Paid Service subscribers. If
          you purchase a subscription to a Paid Service that includes a free
          trial, you will receive free access to such Paid Service for the
          duration of the free trial period. At the end of the applicable free
          trial period, you will be charged the price of the subscription and
          will continue to be charged until you cancel your subscription. To
          avoid any charges, you must cancel before the end of the free trial
          period.
        </p>
        <h5 className="webUi">Pre-Orders</h5>
        <p className="webUi">
          River Comics may offer the ability to pre-order certain items of
          content available within the Paid Services. When you place a pre-order
          for an item of content, unless otherwise noted at the time of
          purchase, your transaction will be completed and your credit card will
          be charged on the date when the relevant item of content is made
          available to you. You can cancel your pre-order at any time up to the
          point at which the relevant item of content becomes available. In some
          cases, River Comics may need to cancel a pre-order you have placed, in
          which case we will notify you.
        </p>
        <h5 className="webUi">Promotional Offers</h5>
        <p className="webUi">
          The offers contained in any electronic communications, announcements,
          promotions, promo-codes, etc. made by River Comics{" "}
          <strong>(“Promotional Offers”)</strong> are targeted/intended only for
          users registering with River Comics through the Application or
          Website. Any such Promotional Offer is not intended for, nor can it be
          availed by, minors and person who are incompetent to contract as per
          New Jersey, US laws. Any acceptance of any such Promotional Offers or
          any transactions attempted by these persons on the Website/the
          Application, shall be invalid and void ab-initio.
          <br />
          Upon availing the Promotional Offers, you shall be deemed to have
          read, understood and accepted these Terms.
          <br />
          The announcement, offer, modification or cancellation of any of the
          Promotional Offers shall be at the sole discretion of River Comics at
          all times. River Comics has the right to cancel/ modify the
          Promotional Offers at will and at any time (including during the
          validity period of such Promotional Offers), without being required to
          give any prior intimation to you. You shall not have any rights or
          claims against River Comics with respect to any such Promotional
          Offers. River Comics shall use its best efforts to ensure the
          fulfillment/performance of the Promotional Offers. However, if for any
          reasons, such Promotional Offers cannot be fulfilled or performed
          successfully, River Comics shall not be liable or responsible for any
          losses or damages you may incur.
          <br />
          You may also enjoy any of the promotional offers and other
          services/facilities provided to you on the Website/the Application by
          Merchants or strategic partners or any other third parties with whom
          River Comics has a tie-up/ affiliation. In case of any such offers,
          services/facilities, you shall not have any rights or claims against
          River Comics. River Comics does not guarantee, and shall not be liable
          or responsible (directly or indirectly) for, the performance of any
          such offers, services/facilities. River Comics shall not be liable for
          any losses or damages you may incur on account of any delay,
          deficiency or failure by such third parties/Merchants in fulfilling
          their obligations, nor shall River Comics be held liable or
          responsible (directly or indirectly) in case of any negligence, error,
          mistake or fault of such third parties/Merchants.
        </p>
        <h5 className="webUi">Loyalty/Rewards Programs</h5>
        <p className="webUi">
          The announcement, offer, modification or cancellation of the River
          Comics Loyalty Program shall be at the sole discretion of River Comics
          at all times. River Comics has the right to cancel/ modify the River
          Comics Loyalty Program at will and at any time (including during the
          validity period of such program), without being required to give any
          prior intimation to you. You shall not have any rights or claims
          against River Comics with respect to any such River Comics Loyalty
          Program. River Comics shall use its best efforts to ensure the
          fulfillment/performance of the River Comics Loyalty Program. However,
          if for any reasons, the River Comics Loyalty Program cannot be
          fulfilled or performed successfully, River Comics shall not be liable
          or responsible for any losses or damages you may incur.
          <br /> You shall not have any rights or claims against River Comics
          with respect to the Merchant’s Loyalty Program. River Comics does not
          guarantee, and shall not be liable or responsible (directly or
          indirectly) for, the performance of the Merchant’s Loyalty Program.
          River Comics shall not be liable (directly or indirectly) for any
          losses or damages you may incur on account of the Merchant’s Loyalty
          Program.
        </p>
        <h5 className="webUi">Privacy</h5>
        <p className="webUi">
          We do not sell or rent your personal information (as defined in the
          Privacy Policy) to any third parties. We view protection of users’
          privacy as a very important community principle. We understand clearly
          that you and your information is one of our most important assets. Our
          current Privacy Policy is available at Privacy Policy. If you object
          to your personal information being transferred or used in this way,
          please do not use the Program.
        </p>
        <h5 className="webUi">Content</h5>
        <p className="webUi">
          Certain portions of the Program may allow you to post or upload text,
          graphics, images, and other content for display or publication on the
          Website/ the Application (“Content”). By submitting Content on the
          Program, you hereby grant us a worldwide, royalty-free, fully paid,
          sub-licensable and transferable license to use, reproduce, distribute,
          prepare derivative works of, display and perform the Content in
          connection with the Program or for promoting River Comics’s business
          in any media formats and through any media channels. If you publish
          images or other such content through the Program, they may be viewed
          by and shared with other users, for example, on social networks like
          Facebook, based on your settings.
          <br /> You agree not to: (i) submit material that violates anyone
          else’s proprietary rights, including intellectual property rights,
          privacy and publicity rights, or can be considered spam or junk mail;
          (ii) knowingly publish false or inaccurate information; (iii) submit
          material that is unlawful, obscene, misleading, defamatory, libelous,
          threatening, pornographic, harassing, hateful, racially or ethnically
          offensive, or encourages conduct that would be considered a criminal
          offense, give rise to civil liability, violate any law, or is
          otherwise inappropriate; (iv) post advertisements, “pyramid schemes,’
          chain letters or other solicitations; or (v) impersonate another
          person and/or host, display, upload, modify, publish, transmit, update
          or share any information which belongs to another person and to which
          you do not have any rights; or (vi) interferes with another user’s
          enjoyment of the Program; (vii) promote through the Program, any
          illegal activities or conduct that is abusive, threatening, obscene,
          defamatory or libelous; or (viii) provide instructional information
          about illegal activities such as making or buying illegal weapons,
          violating someone’s privacy, or providing or creating computer
          viruses; or (ix) try to gain unauthorized access or exceed the scope
          of authorized access to the Website/ the Application; or (x) gain or
          attempt to gain unauthorized access to any portion or feature of the
          Website/Application, or any other systems or servers or networks
          connected to these, by unlawful means such as hacking, password
          “mining” or introducing bugs or viruses; or (xi) create liability for
          River Comics or cause River Comics to lose (in whole or in part) the
          services of its internet service providers or the Merchants or other
          third party vendors.
          <br />
          We do not endorse any Content or any opinion, recommendation, or
          advice expressed therein, and we expressly disclaim any and all
          liability in connection with any Content. We reserve the right to
          decide whether Content is appropriate and complies with the Terms, and
          may remove such Content and/or terminate your access for uploading
          material in violation of the Terms at any time without prior notice.
          We will fully cooperate with any law enforcement authorities or court
          order requesting or directing us to disclose the identity of anyone
          posting publishing or otherwise making available Content or other
          materials that are believed to violate the Terms.
          <br />
          River Comics shall have the right, but not the obligation, to monitor
          the Content of the Program at all times, to determine compliance with
          these Terms or applicable laws and regulation.
        </p>
        <h5 className="webUi">Restrictions</h5>
        <p className="webUi">
          The Program may be used and accessed for lawful purposes only. You
          agree not to, and to not encourage or conspire with anyone else to,
          engage in any conduct that is inconsistent with the purposes, intent
          and spirit of the Program, or otherwise “game the system”. You also
          agree to abide by all applicable local, state, national and foreign
          laws and regulations in connection with your use of the Program. In
          addition, you agree not to do any of the following:
          <br />
          • use the Services to collect or store personal data about other users
          without their express permission;
          <br />• upload, post, email or otherwise transmit any viruses or other
          computer code that may interrupt, destroy, limit the functionality of
          the Services, or interfere with the access of any user to the
          Services;
          <br />• circumvent, disable or otherwise interfere with security
          related features of the Services or features that prevent or restrict
          use or copying of any Content;
          <br />• use any meta tags or other hidden text or metadata utilizing a
          River Comics name, trademark, URL or product name;
          <br />• use manual or automated software, devices, scripts robots,
          other means or processes to access, “scrape,” “crawl” or “spider” any
          web pages contained in the Services;
          <br />• attempt to or actually access the Services by any means other
          than through the Application or the Website or other River
          Comics-provided platforms;
          <br />• attempt to probe, scan or test the vulnerability of any River
          Comics system or network or breach or impair or circumvent any
          security or authentication measures protecting the Program;
          <br />• attempt to decipher, decompile, disassemble, reverse engineer,
          or otherwise attempt to discover or determine the source code of the
          Program;
          <br />• use the Program in any way that competes with River Comics; or
          attempt to or acquire any loyalty points and other rewards, other than
          in a manner consistent with the intended use of the Program;
          <br />• post any product review on a digital distribution platform for
          mobile devices (for example, iTunes Store, Android Market, BlackBerry
          App World), which includes a referral or promo code for collecting or
          receiving rewards through the Program;
          <br />• inaccurately represent the value of a referral or promo code
          reward to any individual; or encourage or instruct any other
          individual to do any of the foregoing.
          <br />• share your River Comics account password with someone else to
          allow them to access any Paid Service that such person did not order
          <br />• use the Paid Service in an illegal manner or for an illegal
          purpose;
          <br />• copy, sell, rent, or sublicense the Paid Services Content to
          any third party
          <br />• access the Paid Service other than by means authorized by
          River Comics; or
          <br />• remove any proprietary notices or labels on Paid Services.
          <br />
          River Comics expressly reserves the right to retroactively reverse any
          rewards or benefits granted to you for any such prohibited conduct, or
          based on any material violation of the Terms; you agree to provide
          your full cooperation and prompt repayment under such circumstances.
          River Comics shall determine, in its sole discretion, whether you have
          engaged in prohibited conduct; River Comics’ determination shall be
          final and unreviewable, and you hereby waive any and all rights you
          may have to challenge that decision. e any and all rights you may have
          to challenge that decision.
        </p>
        <h5 className="webUi">Termination; Cancellation</h5>
        <p className="webUi">
          We may, at our sole discretion and without prior notice to you,
          immediately terminate or suspend your access to the Services and
          remove any material (including any Content provided by you) from the
          Program or our servers, in the event that we believe that you are in
          breach of the Terms. We also reserve the right to terminate the
          Services /Paid Service or your access at any time and for any reason,
          including but not limited to the need to conduct maintenance or if we
          discontinue any portion of the Services. Upon termination, all
          licenses and other rights granted to you under the Terms will
          immediately cease. We will not be liable to you or any other person
          for termination of the Services or termination of your use of the
          Services. Upon any termination or suspension, any information
          (including Content) that you have submitted to the Services may no
          longer be accessed by you. Furthermore, we will have no obligation to
          maintain any information stored in our database related to your
          Account or to forward any information to you or any other person.
          However, your transactions details may be preserved by River Comics
          for purposes of tax or regulatory compliance. You shall be liable to
          pay for any Services availed or Products that you have already ordered
          prior to such termination.
        </p>
        <h5 className="webUi">Ownership</h5>
        <p className="webUi">
          The Program is protected by copyright, trademark, and other applicable
          laws of India. River Comics and its licensors exclusively own all
          right, title and interest in and to the Program, including all
          associated intellectual property rights. You may not remove, alter or
          obscure any copyright, trademark, service mark or other proprietary
          rights notices incorporated in or accompanying the Program. You may
          not use, copy, adapt, modify, prepare derivative works based upon,
          distribute, license, sell, transfer, publicly display, publicly
          perform, transmit, stream, broadcast or otherwise exploit the Program,
          except as expressly permitted in the Terms.
          <br /> Any feedback, comments and suggestions you may provide for
          improvements to the Program <strong>(“Feedback”)</strong> will be the
          sole and exclusive property of River Comics and you hereby irrevocably
          assign to River Comics all of your right, title, and interest in and
          to all Feedback.
        </p>
        <h5 className="webUi">Third Party Links</h5>
        <p className="webUi">
          The Program may contain content or services provided by third parties
          and/or links to third party services, websites or resources. We do not
          have control over them and we are not responsible or liable for the
          availability, accuracy, functionality, adherence to third party
          policies, or legality of, and we do not endorse, such websites,
          services or resources or the content, products, or services on or
          available from such websites or resources. You are solely responsible
          for and assume all risk arising from your use of any such websites,
          services or resources.
        </p>
        <h5 className="webUi">Disclaimers</h5>
        <p className="webUi">
          Your use of the Program is at your sole discretion and risk. We will
          not be responsible for any harm to your computer or mobile device,
          loss of data, personal injury, property damage, or other harm that
          results from your use of the Program. We do not make any warranties:
          (i) regarding the security, accuracy, reliability, timeliness and
          performance of the Program; or (ii) that the Program will be
          error-free or that any errors will be corrected. River Comics will not
          be liable, and you are solely responsible, for any access or usage
          charges charged by your wireless carrier related to any device that
          you use to access or use the Program.
          <br /> We are not responsible for (i) incorrect or inaccurate
          transcription of information, (ii) problems related to any of the
          equipment or software associated with the Program or used by you,
          (iii) human error outside our reasonable control, (iv) any
          interruption, deletion, omission, degradation, defect, or line failure
          of any telephone network or electronic transmission, or (v) problems
          relating to inability to access the Program.
          <br />
          We disclaim all liability for any technical failures or errors of, on,
          or connected to the Program, including but not limited to Push
          Messages sent erroneously due to technical failures or errors. We will
          use reasonable efforts to correct any such failures swiftly upon
          discovering them or being informed about them. If you think you have
          received Push Messages in error or experienced other technical
          failures, please contact us immediately. We will not be held
          responsible for non-availability of the Program during periodic
          maintenance operations or any unplanned suspension of access to the
          Program. You understand and agree that any material and/or data
          downloaded at River Comics is done entirely at your own discretion and
          risk and you will be solely responsible for any damage to your mobile
          or loss of data that results from the download of such material and/or
          data.
          <br />
          We further disclaim any guarantees of exactness as to the finish,
          appearance, size, color etc., of the final Product as ordered by you.
          River Comics Return & Exchange Policy offers. You have the option to
          cancel your subscription/return or exchange the Product purchased on
          River Comics within thirty (30) days of the receipt. In case of return
          of the purchased Product, please refer to the “Return Policy” on our
          Application or Website.
          <br />
          The price of the Products is the price displayed on the Application or
          the Website. We disclaim any revisions with respect to the prices of
          the Product in the invoices raised by the concerned Merchant for the
          Product purchased or reserved by you through the Application or
          Website. Further, the Merchant shall be solely responsible for any
          such revisions in the invoice amounts raised on you and you shall
          solely and exclusively deal with the concerned Merchant in this
          regard. The Program, and all materials, information, products and
          services included therein, are provided on an “AS IS” and “AS
          AVAILABLE” basis without warranties of any kind. WE EXPRESSLY DISCLAIM
          ALL WARRANTIES OF ANY KIND, EXPRESS, IMPLIED OR STATUTORY, RELATING TO
          THE PROGRAM, INCLUDING WITHOUT LIMITATION THE WARRANTIES OF TITLE,
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT OF
          PROPRIETARY RIGHTS, COURSE OF DEALING OR COURSE OF PERFORMANCE. No
          advice or information, whether oral or written, obtained by you from
          River Comics, will create any warranty not expressly stated herein.
        </p>
        <h5 className="webUi">Indemnity</h5>
        <p className="webUi">
          You agree to defend, indemnify, and hold River Comics, its affiliates,
          and their respective officers, directors, employees and agents,
          harmless from and against any claims, liabilities, damages, losses,
          and expenses, including without limitation reasonable attorney’s fees
          and costs, arising out of or in any way connected with (i) your access
          to or use of the Program; (ii) unauthorized access to or alteration of
          River Comics’ transmissions or data(iii) your violation of the Terms,
          Privacy Policy and other terms and conditions and policies as may be
          applicable from time to time (v) your violation of any of the
          applicable laws, rules and regulations; or (iii) your violation of any
          third party right, including without limitation any intellectual
          property right, publicity, confidentiality, property or privacy
          rights.
        </p>{" "}
        <h5 className="webUi">Limitation of Liability</h5>
        <p className="webUi">
          IN NO EVENT WILL RIVER COMICS, ITS OFFICERS, DIRECTORS, EMPLOYEES OR
          AGENTS, BE LIABLE TO YOU FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
          PUNITIVE OR CONSEQUENTIAL DAMAGES OF ANY KIND ARISING OUT OF OR IN
          CONNECTION WITH YOUR USE OF THE PROGRAM OR THE PRODUCTS, WHETHER THE
          DAMAGES ARE FORESEABLE AND WHETHER OR NOT RIVER COMICS HAS BEEN
          ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IN NO EVENT WILL RIVER
          COMICS’S CUMULATIVE LIABILITY TO YOU, FOR ALL CLAIMS REGARDLESS OF
          TYPE, EXCEED FIFTEEN RUPEES.
          <br />
          In addition, from time to time, various entities may sponsor reward
          points, offers and other rewards as part of the Program{" "}
          <strong>(“Sponsors”)</strong>. YOU HEREBY WAIVE AND DISCLAIM ANY AND
          ALL LIABILITY CLAIMS AGAINST RIVER COMICS RELATING IN ANY WAY TO YOUR
          USE OF THE PROGRAM OR ANY SUCH REWARDS. You agree that Sponsors are
          third party beneficiaries of the Terms, and may enforce its provisions
          directly.
        </p>{" "}
        <h5 className="webUi">Governing Law</h5>
        <p className="webUi">
          These Terms shall be governed by and constructed in accordance with
          the laws of New Jersey, USA without reference to conflict of laws
          principles and disputes arising in relation hereto shall be subject to
          the exclusive jurisdiction of the courts of Mumbai.
          <br />
          We may send SMS to you during the following events and the Customer
          agrees to the same:
          <br />
          1. a) A welcome message upon the user joining the Program; and
          <br />
          2. b) In the event the users seek information regarding the tips,
          recommendations and appropriate information pertaining to the Products
          and/or Services offered from various Merchants.
        </p>{" "}
        <h5 className="webUi">Modifications of Terms of Use</h5>
        <p className="webUi">
          River Comics reserves the right to change the terms and conditions in
          this User Agreement at any time and without notice. You will be
          automatically bound by these modifications when you use the
          Website/App; you acknowledge and agree that you are responsible for
          keeping up with any such changes.
        </p>{" "}
        <h5 className="webUi">Assignment</h5>
        <p className="webUi">
          These Terms and Conditions, and any rights and licenses granted
          hereunder, may not be transferred or assigned by you, but may be
          assigned by River Comics without restriction
        </p>{" "}
        <h5 className="webUi">General</h5>
        <p className="webUi">
          The Terms are the entire agreement between you and River Comics
          concerning the Program, and supersede all prior or contemporaneous
          communications between you and River Comics with respect to the
          Program. If any provision of the Terms is deemed invalid by a court of
          competent jurisdiction, the remaining provisions will remain in full
          force and effect. No waiver of any term of the Terms shall be deemed a
          further or continuing waiver of such term or any other term, and River
          Comics’s failure to assert any right or provision under the Terms
          shall not constitute a waiver of such right or provision.
          <br />
          We reserve the right, in our sole discretion, to modify, discontinue
          or terminate any or all of the Program at any time, or modify the
          Terms without notice. All modified terms and conditions will be
          immediately effective as of the date the modified Terns are posted on
          the River Comics website and will apply to all Accounts and users
          enrolled in the Program. If any modified terms and conditions are not
          acceptable to you, your sole remedy is to cease using the Program, and
          if applicable, terminate or cancel your Account. By continuing to
          access or use the Program after we have posted the new terms and
          conditions on the site, you automatically agree to be bound by such
          changes. User will be notified by email or in the Application or
          through other available means if the Program is suspended or
          cancelled. Notice of cancellation will also appear on the Website.
          <br />
          River Comics shall not be liable for any failure to perform its
          obligations hereunder where such failure results from any cause beyond
          River Comics reasonable control, including, without limitation,
          mechanical, electronic or communications failure or degradation
          (including “line-noise” interference). These Terms are personal to
          you, and are not assignable, transferable or sub-licensable by you.
          River Comics may assign, transfer or delegate any of its rights and
          obligations hereunder without consent. No agency, partnership, joint
          venture, or employment relationship is created as a result of these
          Terms and neither party has any authority of any kind to bind the
          other in any respect.
          <br />
          Unless otherwise specified in these Terms, all notices under these
          Terms will be in writing and will be deemed to have been duly given
          when received, if personally delivered or sent by certified or
          registered mail, return receipt requested; when receipt is
          electronically confirmed, if transmitted by facsimile or e-mail; or
          the day after it is sent, if sent for next day delivery by recognized
          overnight delivery service.
          <br />
          If you have any questions about the Terms, please contact us at
          <span
            className="btn btn-link p-0"
            onClick={() => {
              window.location.href = "mailto:support@yuvaquest.com";
            }}
          >
            support@yuvaquest.com
          </span>
        </p>
      </div>
    </>
  );
};
